export const API_STATUS = {
    NG: 'NG',
    OK: 'OK'
}

export const ERROR_MESSAGES = {
    IMAGE_UPLOAD: '画像のアップロードに失敗しました。推奨ファイル形式をご確認ください。',
    DATA_FETCH_ERROR: 'データの取得に失敗しました。',
    NETWORK_ERROR: '通信エラーが発生しました。再度お試しください。',
    INVALID_INPUT: '入力内容に誤りがあります。確認してください。',
}

export const handleApiResponse = (response) => {
    return response.data.status === API_STATUS.NG;
}
